import { api } from '../lib/api'

export type ContentPreferenceSettings = {
  allow_sensitive_nudity: boolean
  allow_sensitive_violence: boolean
  blur_sensitive_previews: boolean
  age_confirmed_18: boolean
  updated_at?: string
}

export async function getContentPreferences(): Promise<ContentPreferenceSettings> {
  const { data } = await api.get<ContentPreferenceSettings>('/api/settings/content-preferences/')
  return data
}

export async function updateContentPreferences(
  payload: Partial<ContentPreferenceSettings>
): Promise<ContentPreferenceSettings> {
  const { data } = await api.put<ContentPreferenceSettings>('/api/settings/content-preferences/', payload)
  return data
}
